/**
 * Design B atelier: the statement lights up word by word on scroll, and the
 * workshop film opens from a framed tile to the full width.
 */
import { scene, revealAll, ambient, releaseAmbient, gsap } from '@theme/clinic-motion';

class ClinicAtelier extends HTMLElement {
  connectedCallback() {
    this.videos = [...this.querySelectorAll('video[data-clinic-ambient]')];
    this.videos.forEach(ambient);

    this.dispose = scene(this, ({ scroller, desktop }) => {
      revealAll(this, { scroller });

      const words = this.querySelectorAll('.clinic-atelier__word');
      if (words.length) {
        gsap.fromTo(
          words,
          { opacity: 0.16 },
          {
            opacity: 1,
            ease: 'none',
            stagger: 0.12,
            scrollTrigger: {
              trigger: this.querySelector('[data-words]'),
              scroller,
              start: 'top 82%',
              end: desktop ? 'bottom 45%' : 'bottom 55%',
              scrub: 0.5,
            },
          }
        );
      }

      const grow = this.querySelector('[data-grow]');
      if (grow) {
        gsap.fromTo(
          grow,
          { clipPath: desktop ? 'inset(14% 26% 14% 26% round 12px)' : 'inset(8% 10% 8% 10% round 12px)' },
          {
            clipPath: 'inset(0% 0% 0% 0% round 12px)',
            ease: 'none',
            scrollTrigger: { trigger: grow, scroller, start: 'top 92%', end: 'center 50%', scrub: 0.6 },
          }
        );
        const inner = grow.querySelectorAll('img, video');
        gsap.fromTo(
          inner,
          { scale: 1.18 },
          {
            scale: 1,
            ease: 'none',
            scrollTrigger: { trigger: grow, scroller, start: 'top bottom', end: 'bottom top', scrub: true },
          }
        );
      }
    });
  }

  disconnectedCallback() {
    this.dispose?.();
    this.videos?.forEach(releaseAmbient);
  }
}

if (!customElements.get('clinic-atelier')) customElements.define('clinic-atelier', ClinicAtelier);
